import type { InjectionKey } from 'vue';

/** When set, Dialog / AlertDialog portals use this z-index class instead of z-50. */
export type DialogPortalStackContext = {
    portalZIndexClass: string;
};

export const dialogPortalStackKey: InjectionKey<DialogPortalStackContext> =
    Symbol('dialogPortalStack');
